module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#magazines",
      toString: function () {
        return this.url;
      }
    }